<div fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row">
    Wybierz, którego regionalnego chcesz zmienić
  </div>

  <div fxLayout="row" fxFlex="100">

    <div fxFlex="50" >
      <mat-slide-toggle [formControl]="changeAssetsRegionalControl">Majątek</mat-slide-toggle>
    </div>

    <div  fxFlex="50">
      <mat-slide-toggle [formControl]="changeLifeRegionalControl">Życie</mat-slide-toggle>
    </div>

  </div>

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">

    <div fxFlex="50" fxLayoutGap="15px">
    <app-dict-regionals fxFlex="100" label="Nowy regionalny - majątek" [control]="assetsRegionalControl"></app-dict-regionals>
    </div>

    <div  fxFlex="50"fxLayoutGap="15px" >
    <app-dict-regionals fxFlex="100" label="Nowy regionalny - życie" [control]="lifeRegionalControl"></app-dict-regionals>
    </div>

  </div>

   <div fxLayout="row" fxFlex="100">
      <mat-slide-toggle [formControl]="changeActiveRegistrationsControl">Czy zmienić regionalnego na panelu OFWCA i rejestracjach aktywnych? </mat-slide-toggle>
   </div>

   <div fxLayout="row" fxFlex="100">
      <mat-slide-toggle [formControl]="changeArchivalRegistrationsControl">Czy zmienić regionalnego tylko w rejestracjach archiwum?</mat-slide-toggle>
   </div>



  <div fxLayout="row">
    <span fxFlex></span>

    <button
      mat-raised-button (click)="sendForm()" color="primary"
      [class.spinner]="processingRequest" [disabled]="(processingRequest || (!assetsRegionalControl.value && !lifeRegionalControl.value) )
      || (!changeArchivalRegistrationsControl.value && !changeActiveRegistrationsControl.value)"
    >Zapisz</button>
  </div>
</div>
